/* eslint-disable import/prefer-default-export */
import React from 'react'
import { RequestProps, useApiRequest } from '@src/hooks/request.hook'

export const useApiRequestWithTimmer = <T, V, R>(
  {
    request,
    reqParams,
    options: { onCallbackError, showToastMessage } = {
      showToastMessage: true
    }
  }: RequestProps<T, V, R>,
  interval: number
) => {
  const mountedRef = React.useRef(true)
  const [countRequest, setCountRequest] = React.useState(0)
  const { response, error, pending } = useApiRequest(
    {
      request,
      reqParams
    },
    [countRequest]
  )

  React.useEffect(() => {
    // Move on to the next call every `n` milliseconds
    const timmer = () =>
      setTimeout(() => {
        setCountRequest(c => c + 1)
      }, interval)

    const timeout: ReturnType<typeof setTimeout> = timmer()
    return () => {
      mountedRef.current = false
      clearTimeout(timeout)
    }
  }, [countRequest])

  return { response, error, pending }
}
